import { IFormViewForm } from 'components/FormView';

const DiaryDetails: IFormViewForm = {
  id: 'DiaryDetails',
  layout: {
    rows: 1,
    columns: 1
  },
  fields: [
    {
      id: '1',
      type: 'PAPER_CONTAINER',
      props: {
        name: 'notepad',
        fullWidth: true
      },
      position: {
        row: 1,
        col: 1,
        colspan: 2
      },
      children: [
        {
          id: 1,
          type: 'DIARY_DETAILS',
          props: {
            label: 'CustomerSalesDiary',
            name: 'CustomerSalesDiary',
            searchByIdApi: '/CustomerEnquiry/Customer/<CustomerId>/SalesDiary/<DiaryId>',
            createApi: '/CustomerEnquiry/Customer/<CustomerId>/CreateSalesDiary',
            updateApi: '/CustomerEnquiry/Customer/<CustomerId>/SalesDiary/<DiaryId>',
            deleteApi: '/CustomerEnquiry/Customer/<CustomerId>/SalesDiary/<DiaryId>',
            diaryType: 'SALES'
          }
        }
      ]
    }
  ]
};
export default DiaryDetails;
